import { useState } from "react";
import { Lock, Loader2, ShieldCheck } from "lucide-react";
import { adminLogin, apiError } from "@/lib/adminApi";

export function AdminLogin({ onSuccess }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await adminLogin(password);
      onSuccess();
    } catch (err) {
      setError(apiError(err, "Could not sign in"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-20">
      <div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm" data-testid="admin-login-card">
        <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-[#0F172A] text-white"><Lock className="h-6 w-6" /></div>
        <h1 className="mt-5 font-heading text-2xl font-bold text-slate-900">Rules administration</h1>
        <p className="mt-1 text-sm text-slate-600">Enter the admin password to edit stream cutoffs, status and point grids.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <input type="password" value={password} autoFocus data-testid="admin-password-input" placeholder="Admin password"
            onChange={(e) => setPassword(e.target.value)}
            className="w-full rounded-md border border-slate-300 px-3.5 py-2.5 text-slate-900 shadow-sm outline-none focus:border-[#C8102E] focus:ring-2 focus:ring-[#C8102E]/20" />
          {error && <p className="rounded-md bg-[#FEF2F2] px-3 py-2 text-sm font-medium text-[#991B1B]" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={busy || !password} data-testid="admin-login-submit"
            className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-[#C8102E] px-4 py-2.5 text-sm font-semibold text-white hover:bg-[#A60C24] disabled:opacity-60">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ShieldCheck className="h-4 w-4" />} Sign in
          </button>
        </form>
        <p className="mt-4 text-xs text-slate-400">Sessions last 8 hours. Five failed attempts lock sign-in for 15 minutes.</p>
      </div>
    </div>
  );
}
